import { createContext, useContext } from 'react';

import { type AreaFit, type FitLevel, UNFITTED } from './useFitLevel';

const AreaFitContext = createContext<AreaFit>(UNFITTED);

/** Wraps a page's content with the fit `useFitLevel` chose, so sections read it without props. */
export const AreaFitProvider = AreaFitContext.Provider;

/** The current fit level; 0, the full design, outside a fitted page. */
export function useAreaFit(): FitLevel {
  return useContext(AreaFitContext).level;
}

/** The certified preview height, the gap above the "more below" cue, and whether the first screen overflows. */
export function useAreaFold(): Pick<AreaFit, 'foldGap' | 'overflows' | 'previewHeight'> {
  const { foldGap, overflows, previewHeight } = useContext(AreaFitContext);
  return { foldGap, overflows, previewHeight };
}
